var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 365.83 16.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #359d8e;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #349c8d;\n        stroke-miterlimit: 2.61;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        stroke-width: .22px;\n      }\n\n      .cls-5, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke-width: .5px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        fill: #349c8d;\n      }\n\n      .cls-8, .cls-6, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-9 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-10 {\n        fill: #231f20;\n        font-family: SegoeUI-Semibold, 'Segoe UI';\n        font-size: 13px;\n        font-weight: 600;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(17.12 11.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " Clinic@ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 62.3,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.79,
    y: 0
  }, "eloc"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 92.97,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.64,
    y: 0,
    xmlSpace: "preserve"
  }, "dental.com      077 941 4836 | 011 250 1094")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 0.61,
    width: 16.29,
    height: 11.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m1.79,1.03c-1.01.19-1.4.93-1.4,1.93v6.65c0,1.19.07,1.93.99,2.35.61.28,8.15.15,9.84.14.86,0,2.55.1,3.31-.02,1.04-.17,1.4-.99,1.39-1.94,0-1.11,0-2.22,0-3.32,0-.77.12-4.24-.15-4.81-.19-.4-.45-.66-.85-.85-.61-.28-8.12-.14-9.83-.14-.77,0-2.68-.09-3.3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1.18,2.44c.18.26,2.83,2.06,3.32,2.4.57.4,1.12.8,1.69,1.18.77.51,1.8,1.44,3.05.59l4.22-2.95c.33-.23,1.47-.99,1.64-1.22-.26-.94-1.7-.68-3.12-.67H2.48c-.73,0-1.08.08-1.29.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1.19,10.65c.21.85,1.12.69,2,.69h9.45c.5-.01,1.06.01,1.56-.01.55-.03.76-.26.91-.68-.17-.2-4.82-3.49-5.13-3.63-.58.36-.89.68-1.84.67-.75,0-1.38-.31-1.81-.68-.33.13-5.09,3.55-5.14,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m10.73,6.54c.21.26,4.29,3.05,4.43,3.11V3.44c-.34.15-1.83,1.26-2.24,1.55l-2.19,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1.16,9.66c.15-.06,4.35-3.04,4.41-3.12-.24-.23-.81-.58-1.09-.77-.38-.26-.7-.51-1.1-.78-.74-.5-1.49-1.05-2.2-1.54l-.02,6.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 191.74,
    y: 0.61,
    width: 7.09,
    height: 12.82,
    rx: 1.69,
    ry: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 192.61,
    y: 1.94,
    width: 5.36,
    height: 9.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 194.6,
    y: 1.23,
    width: 1.37,
    height: 0.21,
    rx: 0.11,
    ry: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m195.21,11.48c.36,0,.65.29.65.65s-.29.65-.65.65-.65-.29-.65-.65.29-.65.65-.65Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/Footer.860018aa79db646bd739662c5722bf96.svg";
export { ForwardRef as ReactComponent };